import { withOidcSecure } from '@axa-fr/react-oidc-context';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AsyncComponent from '../../util/asyncComponent';

function Auth(props: any) {
  const routeMatch = props.match;

  return (
    <div className="gx-main-content-wrapper">
      <Switch>
        <Route
          path={`${routeMatch.url}/logout`}
          component={withOidcSecure(
            AsyncComponent(() => import('./LogOutPage')),
          )}
        />
      </Switch>
    </div>
  );
}

export default Auth;
